export default __webpack_public_path__ + "static/media/ISEO CLASS-5 EXAM PATTERN 2025.9f5d2a95.pdf";